module.exports = __webpack_public_path__ + "sacha.20ff66d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/components/Party/sacha.jpg
// module id = 636
// module chunks = 0